import { Button } from 'component/Button'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { employeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'
import { boutique } from 'page/catalog/employee/store/BoutiqueController'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { emdash } from 'util/typo'

export const LogoutStep = observer(() => {
  const store = employeeModal.it
  const { user_id, name, email, picture } = store.data!

  const onRemove = useLatestCallback(() => {
    employee.remove(user_id)
    boutique.logout()
    if (!employee.employees.length) store.step = 'login'
  })

  const onLogout = useLatestCallback(async () => {
    boutique.logout()
  })

  return <Vertical gap={16}>
    <Space accent pad={8} round={6} opposite>
      <Space gap={8}>
        <Space height={32} round={16} oh>
          {picture && <Image src={picture} fit />}
        </Space>
        <Vertical left gap={2}>
          <Typo size={11} upper medium>
            {name || emdash}
          </Typo>
          <Typo size={13} secondary>
            {email || emdash}
          </Typo>
        </Vertical>
      </Space>
      <Space button pad={8} round={6} center onClick={onRemove}>
        <Icon size={16} name="delete" />
      </Space>
    </Space>
    <Button height={48} action={onLogout}>
      {i18n('Logout')}
    </Button>
  </Vertical>
})
